import { PageContainer } from '@/components/atomic/PageContainer'
import { PageMetaData } from '@/components/atomic/PageMetaData'
import { Header } from '@/components/styleguide/Header'
import { ROUTES } from '@/lib/routes'

export default function ReferAFriendTermsPage() {
  return (
    <>
      <PageMetaData
        title="Terms &amp; Conditions for our Refer a Friend offer | LeaseLoco"
        description="Read the Terms and Conditions of our Refer a friend offer. Find out all you need to know about this great perk from LeaseLoco."
        pageUrl={ROUTES.referAFriendTermsPage.url}
      />
      <Header />
      <PageContainer containerClass="container--terms">
        <h1>Referrals - Terms and Conditions</h1>
        <p>
          Your Amazon Voucher will be emailed to you once your referred friend has successfully
          claimed their Amazon Voucher Reward for leasing a car through LeaseLoco.
        </p>
        <p>You can refer as many people as you like.</p>
        <p>You will only be eligible for one Amazon Reward Voucher for each referral.</p>
        <p>
          If you refer someone who has already been referred by another user, you will not be
          eligible for an Amazon Reward Voucher.
        </p>
        <p>
          Your friend must sign up using your referral link in order for us to track the sign up and
          assign it against you.
        </p>
        <p>
          The LeaseLoco referral bonus amount may increase or decrease at any time. When the
          referral bonus amount has changed, you will be eligible to receive the amount that was
          advertised on the site at the time your friend signed up from your link, which may be
          different to the amount offered when you sent the link to your friend or when the bonus
          was applied to your account.
        </p>
        <p>
          Reward vouchers will only be paid to users who have leased at least one car through
          LeaseLoco, and claimed a reward for leasing their car. This will activate all pending or
          future rewards due to you. Therefore, you can accumulate rewards but they will not be paid
          until we have confirmed that you have leased a car through LeaseLoco. Accumulated rewards
          will appear in your rewards history.
        </p>
      </PageContainer>
    </>
  )
}
